import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { BiGitPullRequest } from 'react-icons/bi';

const FixDescription: FC<React.PropsWithChildren<FixDescriptionProps>> = ({
  title,
  description,
}) => {
  return (
    <Box display='flex' mb={1} alignItems='center'>
      <Box display='flex' alignItems='start'>
        <div>
          <BiGitPullRequest fontSize={40} />
        </div>
        <Box display='flex' flexDirection='column' alignItems='start'>
          <Typography variant='h6' ml={1}>
            {title}
          </Typography>
          <Typography variant='body2' ml={1}>
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export interface FixDescriptionProps {
  title: string;
  description: string;
}

export default FixDescription;
